export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const LOADING_USER = "LOADING_USER";
export const MARK_NOTIFICATIONS_READ = "MARK_NOTIFICATIONS_READ";

export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const LOADING_DATA = "LOADING_DATA";
export const STOP_LOADING_UI = "STOP_LOADING_UI";

export const SET_NEWS = "SET_NEWS";
export const SET_NEW = "SET_NEW";
export const LIKE_NEWS = "LIKE_NEWS";
export const UNLIKE_NEWS = "UNLIKE_NEWS";
export const DELETE_NEWS = "DELETE_NEWS";
export const POST_NEWS = "POST_NEWS";
export const SUBMIT_COMMENT = "SUBMIT_COMMENT";
